import React, { useState } from 'react';

export default function PartsUploader({ onReady, onManual }) {
  const [error, setError] = useState(null);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (ext !== 'csv' && ext !== 'xlsx') {
      setError('Please upload a CSV or Excel (.xlsx) file.');
      return;
    }

    setError(null);
    onReady(file);
  };

  // shared style tokens
  const card = 'glass-card';
  const input =
    'glass-input block w-full text-sm file:mr-4 file:rounded-md file:border-0 file:bg-amber-400 file:px-3 file:py-1.5 ' +
    'file:text-sm file:font-medium file:text-zinc-900 hover:file:bg-amber-300 focus:outline-none focus:ring-2 focus:ring-amber-400/70';

  return (
    <div className={`${card} p-6`}>
      <h2 className="text-lg font-semibold text-amber-300 mb-4">
        1. Upload Parts List{' '}
        <span className="text-zinc-500 text-sm">(CSV or XLSX)</span>
      </h2>

      <label className="block text-sm font-medium text-zinc-400 mb-2">
        Choose File:
      </label>

      <input
        type="file"
        accept=".csv,.xlsx"
        onChange={handleFile}
        className={input}
      />

      {error && (
        <p className="mt-3 text-sm text-red-300">
          {error}
        </p>
      )}

      <div className="mt-4 space-y-2 text-sm text-zinc-400">
        <p className="text-xs text-zinc-500">
          No file handy? You can start fresh and type the items yourself.
        </p>
        <button
          type="button"
          onClick={() => { setError(null); onManual?.(); }}
          className="inline-flex items-center justify-center rounded-lg border border-white/15 bg-white/5 px-4 py-2 text-sm font-medium text-zinc-200 hover:bg-white/10 transition"
        >
          Enter Items Manually
        </button>
      </div>
    </div>
  );
}
